import { AfterViewInit, Component, Input, OnChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '@services/notification.service';
import { RoleManagementService } from '@services/role.management.service';
import { TestService } from '@services/test.service';
import { EMPTY, Subject, Subscription } from 'rxjs';
import { debounceTime, finalize, startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DelMessageComponent } from 'src/app/shared/del-message/del-message.component';
import { Tags } from './tags';
import { WebErrorService } from '@services/webError.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tests-tags',
  templateUrl: './tests-tags.component.html',
  styleUrls: ['./tests-tags.component.scss']
})
export class TestsTagsComponent implements OnChanges, AfterViewInit {
  @Input() isPublished: boolean;
  displayedColumns: string[] = ['tagTypeName', 'tagDescription', 'testTagId'];
  testId: number;
  tags = new MatTableDataSource<any>([]);
  filteredtags: any[] = [];
  tagsforTable: any[] = [];
  tagsForm: FormGroup;
  isLoading = false;
  flatTags: any[] = [];
  flatTagsforTable: any[] = [];
  globalcollectionuuid: any;
  @Input() tabData: any;
  messageFlag = false;
  success = false;
  error = false;
  messages = '';
  duplicateTag = false;
  isNoTags = false;
  tag: any;
  routeSubscription: Subscription;
  showPaginator = false;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  private unsubscribe: Subject<void> = new Subject<void>();

  constructor(
    public roleSer: RoleManagementService,
    private testService: TestService,
    private actRoute: ActivatedRoute,
    private fb: FormBuilder,
    private webErrorService: WebErrorService,
    private dialog: MatDialog,
    private router: Router,
    private notificationService: NotificationService,
    public translate: TranslateService
  ) {
    this.tagsForm = this.fb.group({
      userInput: null
    });
    this.roleSer.getPermissionForTags(this.roleSer.accessData);
  }

  ngAfterViewInit(): void {
    this.tags.paginator = this.paginator;
    this.tags.sort = this.sort;
    // ------Set translation for pagination------
    if(this.tags.paginator) {
      this.showPaginator = true;
      this.translate.stream([
        'testId.TabTags.pagination.pageLabel',
        'testId.TabTags.pagination.firstPage',
        'testId.TabTags.pagination.lastPage',
        'testId.TabTags.pagination.nextPage',
        'testId.TabTags.pagination.prevPage'
      ]).pipe(takeUntil(this.unsubscribe)).subscribe(translation => {
          this.tags.paginator._intl.itemsPerPageLabel = translation['testId.TabTags.pagination.pageLabel'];
          this.tags.paginator._intl.firstPageLabel = translation['testId.TabTags.pagination.firstPage'];
          this.tags.paginator._intl.lastPageLabel = translation['testId.TabTags.pagination.lastPage'];
          this.tags.paginator._intl.nextPageLabel = translation['testId.TabTags.pagination.nextPage'];
          this.tags.paginator._intl.previousPageLabel = translation['testId.TabTags.pagination.prevPage'];

          this.tags.paginator._intl.changes.next();
      });
    }
  }

  @Input() set item(data) {
    if (data) {
      this.isPublished = false;
      this.globalcollectionuuid = JSON.parse(sessionStorage.getItem('defaultcollectionuuid'));
      this.getTestTag()
      this.getSearchedTag();
    }
  }

  getSearchedTag(){
    if(!this.isPublished && this.roleSer.accessData && (this.roleSer.accessData.insertAllowed || this.roleSer.accessData.updateAllowed)){
      this.tagsForm.get('userInput')!.valueChanges.pipe(
        debounceTime(100),
        startWith(''),
        tap(() => this.isLoading = true),
        switchMap(value => value?.length > 1 ? this.testService.getAllTagsForItem(this.globalcollectionuuid, this.testId, value) : EMPTY
          .pipe(finalize(() => this.isLoading = false))
        )
      ).subscribe(tags => {
        this.isLoading = false
        this.filteredtags = tags?.data;
        this.flatTags = [];
        this.filteredtags.forEach(t => {
          t?.tags?.forEach((element: any) => {
            let a = {
              ...element,
              tagtypename: t.tagtypename
            }
            this.flatTags.push(a);
          });
        })
        this.tagsForm.get('userInput')?.valueChanges.subscribe(data => {
          if (data.length == 0) {
            this.flatTags = [];
            // this.isLoading = true
          }
        });
      },
        (error: any) => {
          this.webErrorService.handleAPIErrors(error);
        });
    };
  }

  getTestTag() {
    this.actRoute.paramMap.pipe(
      switchMap((params: any) => {
        this.testId = params.get('id');
        return this.testService.getTestTags(this.testId);
      }
      )).subscribe(
        resData => {
          this.tag = resData?.data;
          if (this.tag?.length == 0) {
            this.isNoTags = true;
          }
          else {
            this.tag = new MatTableDataSource(this.tag);
            this.tag.sort = this.sort;
            this.tag.paginator = this.paginator;
            this.isNoTags = false;
            if (this.tag.paginator) {
              this.tag.paginator.firstPage();
            }
          }
          this.tagsforTable = resData?.data;
          this.flatTagsforTable = [];
          this.tagsforTable.forEach(t => {
            t?.tags.forEach((element: any) => {

              let a = {
                ...element,
                tagtypename: t.tagtypename
              }
              this.flatTagsforTable.push(a);
            });

            this.tags.data = this.flatTagsforTable;
            this.tags.sort = this.sort;
            this.tags.paginator = this.paginator;
          })
        },
        (error: any) => {
          this.webErrorService.handleAPIErrors(error);
        });
  }

  ngOnChanges(): void {
    this.testService.updateTestStatus.subscribe(isTestDisabled => {
      if (isTestDisabled == true) {
        this.isPublished = isTestDisabled;
      } else {
        this.isPublished = false;
      }
    })
    if (this.tabData) {
      this.messageFlag = false;
    }
  }

  openConfirmationDialog(testTagId: any) {
    const dialogRef = this.dialog.open(DelMessageComponent, {
      data: {
        message: this.translate.instant('testId.TabTags.deletePopup.message'),
        buttonText: {
          ok: this.translate.instant('testId.TabTags.deletePopup.btnYes'),
          cancel: this.translate.instant('testId.TabTags.deletePopup.btnNo')
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.testService.deleteTagFromTest(testTagId).subscribe(resData => {
          this.testService.getTestTags(this.testId).subscribe(tagsData => {
            this.flatTagsforTable = [];
            if (tagsData?.data?.length == 0) {
              this.tags.data = this.flatTagsforTable;
              this.isNoTags = true;
            }
            tagsData?.data?.forEach((t: any) => {
              t?.tags.forEach((element: any) => {
                let a = {
                  ...element,
                  tagtypename: t.tagtypename
                }
                this.flatTagsforTable.push(a);
              });
              this.tags.data = this.flatTagsforTable;
            });
          },
            (error: any) => {
              this.webErrorService.handleAPIErrors(error);
            });

          this.notificationService.success(resData?.message);
        },
          (error: any) => {
            this.webErrorService.handleAPIErrors(error, null, true, 'warn');
          });

      }
    });

  }

  addTagtoItem(tagData: Tags) {
    this.testService.addTestTag(this.testId, tagData.tagId, 0).subscribe(
      (resData) => {
        if (resData) {
          this.isNoTags = false;
          this.getTestTag();
          this.tagsForm.get('userInput')?.setValue("");
          this.notificationService.success(resData?.message)
        }
      },
      (error: any) => {
        this.tagsForm.get('userInput')?.setValue("");
        this.webErrorService.handleAPIErrors(error, null, true, 'warn');
      });

  }


  displayFn(tags: Tags): string {
    let seprator: string = "-";
    if (tags) {
      return tags.tagtypename + seprator + tags.tagName;
    }
    return '';
  }

  ngOnDestroy() {
    this.isPublished = null;

    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}

